import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

import { LanguageToggle } from "../../shared/components/language-toggle/language-toggle";
import { AuthStore } from '../../core/services/auth-store';
import { Sidebar } from '../../core/services/sidebar';
import { TimeAgoPipe } from '../../shared/pipes/time-ago-pipe';
import { Popup } from '../../core/services/popup';
import { Header } from '../../core/services/header';

@Component({
  selector: 'app-settings',
  imports: [TranslatePipe, LanguageToggle, CommonModule, RouterLink, TimeAgoPipe],
  templateUrl: './settings.html',
  styleUrl: './settings.css'
})

export class Settings implements OnInit {
  profileImage: string | ArrayBuffer | null = null;
  lastChangedDate = new Date('2025-10-01');

  user: { name: string; initials: string; profileImage?: string } = {
    name: '',
    initials: '',
  };

  constructor(
    private router: Router,
    private authStore: AuthStore,
    private sidebarService: Sidebar,
    private popup: Popup,
    private headerService: Header
  ) { }

  ngOnInit() {
    this.loadUserInfo();
    this.sidebarService.setLinks([{ label: 'SETTINGS.BACK_TO_ACCOUNTS', route: '/accounts', iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' }]);

    this.headerService.updateConfig({
      showRightSection: false
    })
  }


  private loadUserInfo() {
    const userData = this.authStore.getUser(); // todo: replace with actual store call
    if (userData) {
      this.user.name = userData.name;
      this.user.profileImage = userData.profileImage;
      this.user.initials = userData.name
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .toUpperCase();
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      this.profileImage = reader.result;

      this.popup.show({
        message: 'SETTINGS.PROFILE_CHANGED',
        type: 'success',
        duration: 3000,
        position: 'bottom',
        icon: 'assets/icons/check-popup.svg',
      });
    };
    reader.readAsDataURL(file);
  }

  showtermsCondition() {
    const pdfUrl = 'https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf'; //todo fix this later
    window.open(pdfUrl, '_blank');
  }

  handleChangePasswordNav() {
    this.router.navigate(['/change-password'], { queryParams: { from: 'settings' } });
  }
}
